import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Futuristic%20Asian%20digital%20city%20at%20night%20with%20glowing%20holographic%20data%20streams%20and%20network%20connections%2C%20warm%20golden%20and%20amber%20light%20accents%2C%20modern%20skyscrapers%20with%20neon%20signs%2C%20cinematic%20atmosphere%2C%20clean%20composition%2C%20digital%20art%20style&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="亚洲数字生活"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm mb-6 animate-fade-up">
            <i className="ri-sparkling-2-line"></i>
            <span>亚洲领先的数字生活平台</span>
          </div>

          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 animate-fade-up-delay-1">
            亚洲数字生活
            <br />
            <span className="text-primary-400">触手可及</span>
          </h2>

          <p className="text-base md:text-lg text-background-100/80 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-up-delay-2">
            覆盖娱乐、资讯、购物、社交等多元场景，为亚洲用户提供流畅、安全、本地化的在线体验。
            无论身处亚洲何地，精彩数字生活一键即达。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up-delay-3">
            <Link
              to="/about"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-all whitespace-nowrap cursor-pointer"
            >
              立即体验
            </Link>
            <Link
              to="/category/news"
              className="px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium rounded-full text-base transition-all whitespace-nowrap cursor-pointer"
            >
              探索资讯
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12 max-w-3xl mx-auto animate-fade-up-delay-4">
            {[
              { num: '5000万+', label: '注册用户' },
              { num: '12个', label: '覆盖国家' },
              { num: '8种', label: '支持语言' },
              { num: '99.9%', label: '服务可用率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.num}</div>
                <div className="text-xs md:text-sm text-background-100/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}